// Conversation's controls strip. On top of the family's it carries an answer filter, whose
// options are the question's own variants -- each keyed by the id the config stores, and shown
// without its logic markers.

import { questionPositionToId } from '@aytm/app/stats/page/components/lib/utils'
import { removeLogicFromText } from '@aytm/app/stats/page/components/lib/utils'
import { calcControlsProps as calcOeControlsProps } from '@aytm/app/stats/page/question-views/oe/lib/props/controls'

export const calcControlsProps = inputs => {
  const { position, questionId, answerVariants } = inputs

  const props = calcOeControlsProps(inputs)
  const id = String(questionPositionToId(position || questionId)).toLowerCase()

  const items = (answerVariants || [])
    .filter(av => av)
    .map(av => ({ id: `${id}a${av.position}`, text: removeLogicFromText(av.text), position: av.position }))

  return { ...props, model: { ...props.model, items } }
}
